module.exports = __webpack_public_path__ + "img/banner_promo_sky_03.4677b15e.png";